import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function apiErr(e, fallback = "Algo no ha ido bien. Inténtalo de nuevo.") {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Polls an async job until DONE/FAILED. Calls onStage(stageIndex) on each tick.
export async function pollJob(jobId, onStage, { attempts = 90, delay = 2500 } = {}) {
  for (let i = 0; i < attempts; i++) {
    try {
      const { data } = await api.get(`/jobs/${jobId}`);
      if (typeof data.stage_index === "number") onStage?.(data.stage_index);
      if (data.status === "DONE" || data.status === "FAILED") return data;
    } catch {}
    await new Promise((r) => setTimeout(r, delay));
  }
  return { status: "FAILED" };
}

export default api;
